export default [
  {
    path: '/views/popup/:component',
    component: () => import('../components/container/Popup.vue'),
    children: [
      {
        path: '',
        component: () => import('../components/popup/Wrapper.vue'),
      },
    ],
  },
];
